<template>
  <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
    <md-dialog-title>Chỉnh sửa giá trị</md-dialog-title>
    <div class="md-layout container dialogContainer">
      <div class="md-layout-item">
        <md-field>
          <label>Mã sản phẩm:</label>
          <md-input v-model="cartItem.productId" disabled></md-input>
        </md-field>
        <md-field>
          <label>Tên sản phẩm:</label>
          <md-input v-model="cartItem.productName" disabled></md-input>
        </md-field>
        <md-field>
          <label>Số lượng tồn:</label>
          <md-input v-model="cartItem.warehouse" disabled></md-input>
        </md-field>
        <md-chips v-model="cartItem.promotion" md-placeholder="Thêm CTKM">
          <label>CTKM:</label>
        </md-chips>
        <md-field>
          <label>Giá niên yết:</label>
          <md-input v-model="cartItem.productCost" disabled></md-input>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>Đơn vị tính:</label>
          <md-input v-model="cartItem.unit" disabled></md-input>
        </md-field>
        <md-field>
          <label>Số lượng đặt:</label>
          <md-input
            v-model="cartItem.number"
            @change="changeNumber"
            type="number"
          ></md-input>
        </md-field>
        <md-field>
          <label>Chiết khấu(%):</label>
          <md-input
            v-model="cartItem.discountValue"
            @change="changeDiscountValue"
            type="number"
          ></md-input>
        </md-field>
        <md-field>
          <label>Giá bán:</label>
          <md-input
            v-model="pricing"
            @change="changePricing"
            type="number"
          ></md-input>
        </md-field>
        <md-field>
          <label>Tổng giá trị chiết khấu:</label>
          <md-input
            v-model="cartItem.discountAmount"
            @change="changeDiscountAmount"
            type="number"
          ></md-input>
        </md-field>
        <md-field>
          <label>Tổng tiền:</label>
          <md-input v-model="cartItem.amount" type="number" disabled></md-input>
        </md-field>
      </div>
    </div>
    <md-dialog-actions>
      <md-button class="md-success md-dense" @click="updateCartItem()"
        >Lưu</md-button
      >
      <md-button class="md-danger md-dense" @click="cancelUpdateCartItem()"
        >Hủy</md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
export default {
  props: ["showDialog", "cartSelected"],
  data() {
    return {
      cartItem: {},
      pricing: 0,
    };
  },
  methods: {
    changeNumber() {
      this.cartItem.discountAmount =
        (this.cartItem.productCost - this.pricing) * this.cartItem.number;
      this.cartItem.amount = this.pricing * this.cartItem.number;
    },
    changeDiscountValue() {
      this.pricing =
        this.cartItem.productCost -
        (this.cartItem.productCost * this.cartItem.discountValue) / 100;
      this.cartItem.discountAmount =
        (this.cartItem.productCost - this.pricing) * this.cartItem.number;
      this.cartItem.amount = this.cartItem.number * this.pricing;
    },
    changePricing() {
      this.cartItem.discountValue =
        (10000 - (this.pricing / this.cartItem.productCost) * 10000) / 100;
      this.cartItem.discountAmount =
        (this.cartItem.productCost - this.pricing) * this.cartItem.number;
      this.cartItem.amount = this.cartItem.number * this.pricing;
    },
    changeDiscountAmount() {
      this.cartItem.discountValue =
        ((this.cartItem.discountAmount / this.cartItem.productCost) * 10000) /
        100;
      this.pricing =
        this.cartItem.productCost -
        (this.cartItem.productCost * this.cartItem.discountValue) / 100;
      this.cartItem.amount = this.cartItem.number * this.pricing;
    },
    updateCartItem() {
      this.$emit("updateCartItem", this.cartItem);
    },
    cancelUpdateCartItem() {
      this.$emit("cancelUpdateCartItem");
    },
  },
  created() {
    this.cartItem = JSON.parse(JSON.stringify(this.cartSelected));
    this.cartItem.discountValue = (this.cartItem.discountValue * 100) / 100;
    this.pricing =
      this.cartItem.productCost -
      (this.cartItem.productCost * this.cartItem.discountValue) / 100;
  },
};
</script>
<style scoped>
.dialogContainer {
  width: 50vw;
}
</style>
